import React, { forwardRef, useEffect, useState } from "react";
import noImage from 'assets/img/no-image.png';
import { buildUrl } from "helpers/Url";
import Api from "helpers/Api";

function FilePreview(props, ref) {
    const [state, setState] = useState({
        src: null,
        type: null,
    });

    const file = props.file;
    const width = props.width || props.height || '100%';
    const height = props.height || props.width || '100%';

    useEffect(() => {
        // let src = file ? buildUrl(Api.defaults.baseURL + '/store/files/stream', { file_id: file.id, width: 200 }) : null;
        let src = file ? file.url : null;

        setState(prev => ({
            ...prev,
            src: src || noImage,
            type: file?.file_type,
        }))
    }, [props.file]);

    const handleClick = e => {
        e.preventDefault();

        window.open(e.target.src);
    }

    const handleError = e => {
        // e.target.classList.add('hidden')

        setState(prev => ({
            ...prev,
            src: noImage
        }));
    }

    // тук може да се добави load effect
    const handleLoad = e => {
        let img = e.target;

    }

    // console.log(state.src);

    return (
        <picture style={{
            width: width,
            height: height,
            aspectRatio: '1/1',
            backgroundImage: 'url(' + state.src + ')',
            backgroundSize: '500%',
            display: 'inline-block',
            boxShadow: '0 0 5px #bbb9b9',
        }}>
            {React.createElement(state.type === 'video' ? 'video' : 'img', {
                src: state.src,
                loading: 'lazy',
                onLoad: e => handleLoad(e),
                onError: e => handleError(e),
                onClick: e => handleClick(e),
                style: {
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                },
                alt: ""
            })}
        </picture>
    )
}

export default forwardRef(FilePreview);